module.exports = [{
      plugin: require('/Users/bundit/code/sawasdee/node_modules/gatsby-plugin-transition-link/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
